<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';
  import { getGroupStore } from '@stores/group';
  import { getGlobalStore } from '@stores/global';

  let reportContentStore = getGlobalStore('reportContentStore');
  let groupStore = getGroupStore('groupStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  let recsStore = getGroupStore('recsStore');
  import ComponentEvents from '@utils/component-events';
  import Notification from '@utils/notification';
  import Track from '@utils/track';
  import { getCurrentUserStore } from '@stores/current_user';
  import Log from '@utils/log';
  import Modal from '@components/Modal.svelte';
  import Alert from '@components/Alert.svelte';

  import RemoveRecObjectModal from '@app-components/modal/RemoveRecObjectModal.svelte';
  import StepTwo from '@app-components/modal/add_rec_external/StepTwo.svelte';
  import DetailViewModal from '@app-components/rec_object/detail_view/DetailViewModal.svelte';
  import SaveButton from '@app-components/SaveButton.svelte';

  import jQuery from 'jquery';
  import queryString from 'query-string';
  import { goto } from '$app/navigation';
  import Icon from '@components/Icon.svelte';
  import {
    ShareIconSvg,
    ErrorIconSvg,
    ListIconSvg,
    EditIconSvg,
    CopyIconSvg,
    DragIconSvg,
    TrashIconSvg,
  } from '@utils/icons';

  const dispatch = createEventDispatcher();

  export let mobile = false;
  export let recObjectId;
  export let actionStyle = '';

  export let beforeAction = function () {};

  export let showShareCard = true;
  export let detailsViewOption = true;
  export let showDuplicate = true;
  export let customGroupStore;
  export let styleAsBrokenLink = false;

  let brokenLink = null;
  let checkForChanged;

  let group = customGroupStore || groupStore;
  let recObject = recObjectsStore.find(recObjectId);
  $: if (recObject) {
    brokenLink = recObject.weblink_broken;
  }
  let recs = [];
  let currentUser = getCurrentUserStore('default');

  let anyRemovableRecs = false;

  export let showStepTwoModal = false;
  export let focusBrokenLink = false;
  export let brokenLinkRelay = false;

  let showRemoveRecModal = false;
  let showDetailViewModal = false;
  let showOptions = false;

  let saveItButtonClicked;
  let shareInput;

  let hideOptions = function () {
    showOptions = false;
  };

  export const displayRecObjectFormModal = function () {
    beforeAction('edit');
    showStepTwoModal = true;
  };

  let displayDetails = function () {
    beforeAction('detail-view');
    showDetailViewModal = true;
  };

  let displayDuplicate = function () {
    beforeAction('duplicate');
    saveItButtonClicked();
  };

  let copyShareLink = function () {
    beforeAction('copy');

    if (mobile && typeof navigator !== 'undefined' && typeof navigator.share != 'undefined') {
      navigator
        .share({ title: recObject.name1, url: recObject.detail_url })
        .then(() => {})
        .catch(() => {});
    } else {
      jQuery(shareInput).css('display', 'block');
      shareInput.select();
      shareInput.setSelectionRange(0, 9999);
      document.execCommand('copy');
      jQuery(shareInput).css('display', 'none');

      Notification.send({ text: 'Link copied' });
    }

    Track.detailviewShareClicked({
      user: currentUser,
      group,
      recObject,
    });

    logCopyEvent();
  };

  let logCopyEvent = function () {
    Log.info(
      `SHARE: Card Link Copied - ${recObject.name1} (who shared: ${currentUser && currentUser.name}, list: ${
        recObject.detail_url
      })`
    );
  };

  let displayOptions = function () {
    showOptions = true;
  };

  let displayRemoveRecObjectModal = function () {
    beforeAction('delete');
    showRemoveRecModal = true;
  };

  let closeStepTwoModal = function () {
    showStepTwoModal = false;
    focusBrokenLink = false;
  };

  let showCancelChangesDialog = false;

  let closeBtnClicked = function () {
    if (checkForChanged && checkForChanged()) {
      showCancelChangesDialog = true;
    } else {
      closeStepTwoModal();
    }
  };

  let unsubClose = ComponentEvents.on('close-all-options-menu', function () {
    showOptions = false;
  });

  $: if (showOptions) {
    ComponentEvents.trigger('close-all-options-menu');
    showOptions = true;
  }

  let popStateListener = function (_event) {
    let detailId = queryString.parse(location.search).detail_id;
    showDetailViewModal = detailId && recObjectId == detailId;
  };

  onMount(() => {
    window.addEventListener('popstate', popStateListener);

    let unsubRecs = recsStore.subscribe((x) => {
      recs = x.where({ rec_object_id: recObject.id });

      recs.forEach((r) => {
        if (r.permissions.delete) {
          anyRemovableRecs = true;
        }
      });
    });

    return () => {
      unsubRecs();
      unsubClose();

      window.removeEventListener('popstate', popStateListener);
    };
  });
</script>

<style style="text/scss" lang="scss">
  .rec-object-actions {
    position: absolute;
    right: 20px;
    top: 15px;
    z-index: 3;
    cursor: pointer;
    &.broken-link {
      position: unset;
      box-sizing: unset;
      height: 24px;
      &.cross {
        height: 16px;
        padding: 4px;
      }
      &:hover {
        svg {
          fill: lightgrey !important;

          path {
            fill: lightgrey !important;
          }
        }
      }
    }

    &:hover {
      svg {
        fill: #7054dc !important;

        path {
          fill: #7054dc !important;
        }
      }
    }
  }

  .options-container {
    position: absolute;
    right: 15px;
    top: 50px;
    width: 210px;
    padding: 15px;
    background: white;
    border-radius: 15px;
    box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.0938593);
    z-index: 2;
    display: flex;
    flex-direction: column;

    .container-option {
      display: flex;
      align-items: center;
      padding: 15px;
      cursor: pointer;
      border-radius: 15px;
      padding-top: 12px;
      padding-bottom: 12px;

      &:hover {
        background: #f5f3fc;
      }

      .container-option-name {
        margin-left: 24px;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        color: #000;
      }
    }
  }

  .close-btn {
    position: absolute;
    right: 15px;
    top: 8px;
    cursor: pointer;

    &:hover {
      path {
        stroke: #a893f9;
        fill: #a893f9;
      }
    }
  }

  .mobile-menu {
    position: fixed;
    right: 30px;
    bottom: 90px;
    z-index: 51;
    width: unset;
    left: 30px;
    top: unset;

    .menu-lbl {
      font-weight: bold;
      font-size: 12px;
      line-height: 15px;
      color: #1a1a1a;
      width: 100%;
      text-align: center;
      margin-bottom: 20px;
      margin-top: 10px;
    }
  }

  .mobile {
    .close-btn {
      zoom: 1.5;
      float: right;
      margin-top: -10px;
      position: unset;

      path {
        fill: black;
      }
    }
  }

  .overlay {
    z-index: 50;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    background: rgba(0, 0, 0, 0.3);
  }

  * :global(.mobile-modal-overlay-class) {
    will-change: unset !important;
  }

  * :global(.mobile-container-class) {
    will-change: unset !important;
  }

  * :global(.step-2-container.mobile) {
    margin-top: 0px !important;
  }

  * :global(.save-alert-modal) {
    // make larger than tooltips on the steptwo modal
    z-index: 10000 !important;
  }
</style>

{#if showRemoveRecModal}
  <RemoveRecObjectModal
    customGroupStore={customGroupStore}
    mobile={mobile}
    recObjectId={recObject.id}
    recIds={recs.map((r) => r.id)}
    bind:showModal={showRemoveRecModal}
    on:removed={() => {
      dispatch('removed', { rec_object_id: recObject.id });
    }} />
{/if}

{#if showStepTwoModal}
  <Alert
    mobile={mobile}
    on:yes-click={() => {
      closeStepTwoModal();
    }}
    class="save-alert-modal"
    question="Exit without saving?"
    yesButtonText="Exit"
    objectText={null}
    bind:show={showCancelChangesDialog} />

  <div class="svelte-modal">
    <Modal
      closeOnOverlayClick={false}
      mobile={mobile}
      allowClose={false}
      on:overlay-clicked={closeBtnClicked}
      bind:show={showStepTwoModal}
      showCloseButton={false}
      fadeInDuration={200}
      overlayClass={mobile ? 'mobile-modal-overlay-class' : ''}
      containerClass={mobile ? 'mobile-container-class' : ''}
      style={mobile
        ? ''
        : 'width: 490px; width: 952px; max-width: 952px; min-height: 380px; height: calc(100vh - 60px); overflow: hidden; padding-bottom: 0px;'}>
      <div slot="content" class:mobile={mobile}>
        <div class="close-btn" on:click={closeBtnClicked}>
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.74169 0.258309C7.39728 -0.0861031 6.83888 -0.0861028 6.49446
          0.258309L4 2.75277L1.50554 0.258309C1.16112 -0.086103 0.602721
          -0.0861031 0.258309 0.258309C-0.0861032 0.602721 -0.0861029 1.16112
          0.258309 1.50554L2.75277 4L0.258333 6.49444C-0.0860796 6.83885
          -0.0860799 7.39726 0.258332 7.74167C0.602744 8.08608 1.16115 8.08608
          1.50556 7.74167L4 5.24723L6.49444 7.74167C6.83885 8.08608 7.39726
          8.08608 7.74167 7.74167C8.08608 7.39726 8.08608 6.83885 7.74167
          6.49444L5.24723 4L7.74169 1.50554C8.0861 1.16112 8.0861 0.602721
          7.74169 0.258309Z"
              fill="#7F7F7F" />
          </svg>
        </div>

        <StepTwo
          customGroupStore={customGroupStore}
          mobile={mobile}
          recObjectId={recObject.id}
          mode="edit"
          doneButtonHtml="Save"
          focusBrokenLink={focusBrokenLink}
          brokenLink={brokenLinkRelay || brokenLink}
          bind:checkForChanged={checkForChanged}
          on:edited={() => (showStepTwoModal = false)} />
      </div>
    </Modal>
  </div>
{/if}

{#if showDetailViewModal}
  <DetailViewModal
    customGroupStore={customGroupStore}
    mobile={mobile}
    showActionBar={true}
    recObjectId={recObject.id}
    bind:showModal={showDetailViewModal} />
{/if}

{#if showDuplicate}
  <div style="display: none;">
    <SaveButton
      customGroupStore={customGroupStore}
      bind:saveItButtonClicked={saveItButtonClicked}
      recObjectId={recObjectId}
      mobile={mobile} />
  </div>
{/if}

{#if showOptions}
  {#if mobile}
    <div class="overlay" on:click|preventDefault|stopPropagation={hideOptions} />
    <div />
  {/if}

  <div class="options-container undraggable" class:mobile-menu={mobile} in:fade={{ duration: 200 }}>
    {#if mobile}
      <div class="menu-lbl">MENU</div>

      <div style="position: absolute; top: 15px; right: 15px;" on:click|preventDefault|stopPropagation={hideOptions}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <rect width="16" height="16" fill="white" />
          </mask>
          <g mask="url(#mask0)">
            <path
              d="M9.53304 8.1179C9.51752 8.10242 9.5052 8.08403 9.4968 8.06378C9.4884 8.04353 9.48407 8.02182 9.48407 7.9999C9.48407 7.97798 9.4884 7.95628 9.4968 7.93603C9.5052 7.91578 9.51752 7.89739 9.53304 7.88191L15.7081 1.70749C15.8956 1.51972 16.0009 1.26516 16.0007 0.999809C16.0005 0.734456 15.8949 0.480045 15.7071 0.292545C15.5194 0.105044 15.2648 -0.000187276 14.9994 2.50204e-07C14.7341 0.000187776 14.4797 0.105779 14.2922 0.293545L8.11776 6.4653C8.10228 6.48082 8.08389 6.49313 8.06364 6.50153C8.04339 6.50994 8.02169 6.51426 7.99976 6.51426C7.97784 6.51426 7.95614 6.50994 7.93589 6.50153C7.91564 6.49313 7.89725 6.48082 7.88177 6.4653L1.70735 0.293545C1.61451 0.20066 1.50428 0.126971 1.38296 0.0766857C1.26164 0.0264001 1.13161 0.000502573 1.00028 0.000471621C0.735052 0.000409111 0.480662 0.105711 0.293073 0.293211C0.105484 0.480712 6.25374e-05 0.735052 2.78145e-08 1.00028C-6.24818e-05 1.26551 0.105239 1.5199 0.29274 1.70749L6.46649 7.88191C6.48201 7.89739 6.49433 7.91578 6.50273 7.93603C6.51113 7.95628 6.51546 7.97798 6.51546 7.9999C6.51546 8.02182 6.51113 8.04353 6.50273 8.06378C6.49433 8.08403 6.48201 8.10242 6.46649 8.1179L0.29274 14.293C0.199899 14.3859 0.126262 14.4961 0.0760337 14.6175C0.0258053 14.7388 -3.09238e-05 14.8689 2.78145e-08 15.0002C6.25374e-05 15.2654 0.105484 15.5198 0.293073 15.7073C0.385958 15.8001 0.496219 15.8737 0.617562 15.924C0.738905 15.9742 0.868953 16 1.00028 16C1.26551 15.9999 1.51985 15.8945 1.70735 15.7069L7.88177 9.53184C7.89725 9.51632 7.91564 9.50401 7.93589 9.49561C7.95614 9.4872 7.97784 9.48288 7.99976 9.48288C8.02169 9.48288 8.04339 9.4872 8.06364 9.49561C8.08389 9.50401 8.10228 9.51632 8.11776 9.53184L14.2922 15.7069C14.4797 15.8945 14.734 15.9999 14.9992 16C15.2645 16.0001 15.5189 15.8948 15.7065 15.7073C15.894 15.5198 15.9995 15.2654 15.9995 15.0002C15.9996 14.735 15.8943 14.4806 15.7068 14.293L9.53304 8.1179Z"
              fill="#7F7F7F" />
          </g>
        </svg>
      </div>
    {/if}

    <!-- edit -->
    {#if group.permissions.edit}
      <div
        class="container-option"
        on:click|preventDefault|stopPropagation={() => {
          hideOptions();
          displayRecObjectFormModal();
        }}>
        <div style="display: flex">
          <Icon name="edit" size={24} path={EditIconSvg} />
        </div>
        <div class="container-option-name">Edit</div>
      </div>
    {/if}

    <!-- share card -->
    {#if showShareCard}
      <div
        class="container-option"
        on:click|preventDefault|stopPropagation={() => {
          hideOptions();
          copyShareLink();
        }}>
        <div style="display: flex">
          <Icon name="share" size={24} path={ShareIconSvg} />
        </div>
        <div class="container-option-name">Share card</div>
      </div>
    {/if}

    <!-- view details-->
    {#if detailsViewOption}
      <div
        class="container-option"
        on:click|preventDefault|stopPropagation={() => {
          hideOptions();
          displayDetails();
        }}>
        <div style="display: flex">
          <Icon name="Details" size={24} path={ListIconSvg} />
        </div>
        <div class="container-option-name">View details</div>
      </div>
    {/if}
    {#if group.users[0].id != currentUser.id}
      <div
        class="container-option"
        on:click|preventDefault|stopPropagation={() => {
          hideOptions();
          // TODO users first sufficient?
          reportContentStore.set({ show: true, params: { rec_object_id: recObjectId }, owner: group.users[0] });
        }}>
        <div style="display: flex">
          <Icon name="report" size={24} path={ErrorIconSvg} />
        </div>
        <div class="container-option-name">Report</div>
      </div>
    {/if}
    <!-- duplicate -->
    {#if showDuplicate && group && group.permissions && group.permissions.edit}
      <div
        class="container-option"
        on:click|preventDefault|stopPropagation={() => {
          hideOptions();
          displayDuplicate();
        }}>
        <div style="display: flex">
          <Icon name="duplicate" size={24} path={CopyIconSvg} />
        </div>
        <div class="container-option-name">Duplicate</div>
      </div>
    {/if}

    {#if group.permissions.edit && mobile}
      <div
        class="container-option"
        on:click|preventDefault|stopPropagation={() => {
          goto(`${group.path_with_user_id}/edit`);
        }}>
        <div style="display: flex">
          <Icon name="move" size={24} path={DragIconSvg} />
        </div>
        <div class="container-option-name">Move</div>
      </div>
    {/if}

    <!-- delete -->
    {#if anyRemovableRecs || recObject.permissions.delete}
      <div
        class="container-option"
        on:click|preventDefault|stopPropagation={() => {
          hideOptions();
          displayRemoveRecObjectModal();
        }}>
        <div style="display: flex">
          <Icon name="delete" size={24} color={'#FF5567'} path={TrashIconSvg} />
        </div>
        <div class="container-option-name" style="color: #FF5567">Delete</div>
      </div>
    {/if}
  </div>
{/if}

{#if !mobile && showOptions}
  <div
    class="rec-object-actions undraggable {brokenLink && styleAsBrokenLink ? 'broken-link' : ''} cross"
    style="top: 20px; {actionStyle}"
    on:click|preventDefault|stopPropagation={hideOptions}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.8821 9.53304C7.89758 9.51752 7.91597 9.5052 7.93622
            9.4968C7.95647 9.4884 7.97818 9.48407 8.0001 9.48407C8.02202 9.48407
            8.04372 9.4884 8.06397 9.4968C8.08422 9.5052 8.10261 9.51752 8.11809
            9.53304L14.2925 15.7081C14.4803 15.8956 14.7348 16.0009 15.0002
            16.0007C15.2655 16.0005 15.52 15.8949 15.7075 15.7071C15.895 15.5194
            16.0002 15.2648 16 14.9994C15.9998 14.7341 15.8942 14.4797 15.7065
            14.2922L9.5347 8.11776C9.51918 8.10228 9.50687 8.08389 9.49847
            8.06364C9.49006 8.04339 9.48574 8.02169 9.48574 7.99976C9.48574
            7.97784 9.49006 7.95614 9.49847 7.93589C9.50687 7.91564 9.51918
            7.89725 9.5347 7.88177L15.7065 1.70735C15.7993 1.61451 15.873 1.50428
            15.9233 1.38296C15.9736 1.26164 15.9995 1.13161 15.9995
            1.00028C15.9996 0.735052 15.8943 0.480662 15.7068 0.293073C15.5193
            0.105484 15.2649 6.25374e-05 14.9997 2.78145e-08C14.7345 -6.24818e-05
            14.4801 0.105239 14.2925 0.29274L8.11809 6.46649C8.10261 6.48201
            8.08422 6.49433 8.06397 6.50273C8.04372 6.51113 8.02202 6.51546 8.0001
            6.51546C7.97818 6.51546 7.95647 6.51113 7.93622 6.50273C7.91597
            6.49433 7.89758 6.48201 7.8821 6.46649L1.70702 0.29274C1.61413
            0.199899 1.50387 0.126262 1.38253 0.0760337C1.26118 0.0258053 1.13114
            -3.09238e-05 0.999808 2.78145e-08C0.73458 6.25374e-05 0.48024 0.105484
            0.292739 0.293073C0.199899 0.385958 0.126261 0.496219 0.0760326
            0.617562C0.0258036 0.738905 -3.05176e-05 0.868953 0
            1.00028C6.19888e-05 1.26551 0.105483 1.51985 0.293073 1.70735L6.46816
            7.88177C6.48368 7.89725 6.49599 7.91564 6.50439 7.93589C6.5128 7.95614
            6.51712 7.97784 6.51712 7.99976C6.51712 8.02169 6.5128 8.04339 6.50439
            8.06364C6.49599 8.08389 6.48368 8.10228 6.46816 8.11776L0.293073
            14.2922C0.105483 14.4797 6.19888e-05 14.734 0 14.9992C-6.29425e-05
            15.2645 0.105239 15.5189 0.292739 15.7065C0.48024 15.894 0.73458
            15.9995 0.999808 15.9995C1.26504 15.9996 1.51943 15.8943 1.70702
            15.7068L7.8821 9.53304Z"
        fill={brokenLink && styleAsBrokenLink ? 'white' : '#d5cfea'} />
    </svg>
  </div>
{:else}
  <div
    class="rec-object-actions undraggable {brokenLink && styleAsBrokenLink ? 'broken-link' : 'regular'}"
    style={actionStyle}
    on:click|preventDefault|stopPropagation={displayOptions}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" xmlns:v="https://vecta.io/nano">
      <mask id="A" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"
        ><path transform="rotate(90 24 0)" fill="#fff" d="M24 0h24v24H24z" /></mask
      ><g mask="url(#A)"
        ><path
          fill-rule="evenodd"
          d="M21 9a3 3 0 1 1 0 6 3 3 0 1 1 0-6zM3 9a3 3 0 1 1 0 6 3 3 0 1 1 0-6zm12 3a3 3 0 1 0-6 0 3 3 0 1 0 6 0z"
          fill={brokenLink && styleAsBrokenLink ? 'white' : '#d5cfea'} /></g>
    </svg>
  </div>
{/if}

<input type="text" style="display: none" bind:this={shareInput} value={recObject.detail_url} />
